import Vue from "vue";
import {
  Notification,
  NotificationType,
  ErrorNotification
} from "@/models/notifications/notification";

export const NotificationServiceBus = new Vue({
  methods: {
    showSuccessMessage(title: string, description?: string): void {
      this.$emit(
        "showMessage",
        new Notification(title, description || null, NotificationType.Success)
      );
    },
    showMessage(notification: Notification): void {
      this.$emit("showMessage", notification);
    },
    showErrorMessage(title: string, description?: string): void {
      this.$emit(
        "showMessage",
        new Notification(title, description || null, NotificationType.Error)
      );
    },
    showError(axios: any) {
      if (axios && axios.response && axios.response.data) {
        const errors = axios.response.data as ErrorNotification[];
        if (errors.length > 0) {
          this.$emit("showMessage", Notification.Convert(errors[0]));
        } else {
          this.$emit(
            "showMessage",
            new Notification("Operação inválida", null, NotificationType.Error)
          );
        }
      } else {
        this.$emit(
          "showMessage",
          new Notification(
            "Connection",
            "Check your connection",
            NotificationType.Error
          )
        );
      }
    }
  }
});
